export const state = {
  cache: {},
  sources: []
};

// Declare state
export type State = typeof state;
